import React, { memo, useCallback, useState, useRef } from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import debounce from 'lodash/debounce';

const INTERVAL_BETWEEN_RENDERS_IN_MS = 300;

type ChangeEvent = React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>;

type Props = Required<Pick<TextFieldProps, 'value' | 'onChange'>> & TextFieldProps;

const ControlledTextField: React.FC<Props> = ({ value: externalValue, onChange, ...props }) => {
  const [value, setValue] = useState(externalValue);

  const debouncedOnChange = useRef(
    debounce((e: ChangeEvent) => {
      onChange(e);
    }, INTERVAL_BETWEEN_RENDERS_IN_MS),
  ).current;

  const handleOnChange = useCallback(
    (e: ChangeEvent) => {
      setValue(e.target.value);
      e.persist();
      debouncedOnChange(e);
    },
    [setValue, debouncedOnChange],
  );

  return <TextField value={value} onChange={handleOnChange} {...props} />;
};

export default memo(ControlledTextField);
